import { createContext, useContext } from "react";

export interface WrapExperienceCardProps {
  thumbnailURL: string;
  name: string;
  author: string | undefined | null;
}

const WrapExperienceCardContext = createContext<{
  card: WrapExperienceCardProps;
} | null>(null);

export function useWrapExperienceCardContext() {
  const context = useContext(WrapExperienceCardContext);

  if (!context) {
    throw new Error(
      "WrapExperienceCard.* component must be rendered as a child of WarpExperienceCard component",
    );
  }

  return context;
}

export default WrapExperienceCardContext;
